import BusinessForm from '@/components/businesses/BusinessForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';

export default function BusinessAddPage() {
  const navigate = useNavigate();

  return (
    <DefaultLayout
      header="Add Business"
      breadcrumb={[
        { label: 'Businesses', href: ROUTES.BUSINESSES },
        { label: 'Add', isActive: true },
      ]}>
      <BusinessForm
        onSuccess={(uuid: string) => navigate(`${ROUTES.BUSINESSES}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
